<template>
  <div
    ref="rightClickTarget"
    class="right-click-menu-wrapper"
    @contextmenu="handleContextMenu($event)"
  >
    <!--@touchstart="handleTouchStart"
    @touchmove="handleTouchEndMove1"
    @touchend="handleTouchEndMove2"-->
    <slot></slot>
    <div v-show="isMenuFlag" ref="menuWrapper" class="menu-card-wrapper" :style="{top: clientY+'px',left: clientX+'px'}">
      <div ref="messageDrop" class="dropdown" @click="callbackMsg(item)">
        <div class="dropdown-menu">撤回</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      isMenuFlag: false,
      clientX: '', // 弹框显示的横纵坐标
      clientY: '',
      touchX: 0, // 手机屏幕开始点击的横纵坐标
      touchY: 0
    }
  },
  mounted() {
    document.addEventListener('click', this.hideDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideDropdown)
  },
  computed: {
    ...mapState(['environment'])
  },
  methods: {
    isSelf(sendType) {
      return !(sendType && (sendType.toUpperCase() === 'SEND' || sendType.toUpperCase() === 'AUTO_REPLY'))
    },
    callbackMsg(item) {
      this.$emit('handleBackMessage', item)
    },
    handleContextMenu(event) {
      const { android, iPad, iPhone } = this.environment
      if (android || iPad || iPhone) return
      const nowTime = new Date().getTime()
      const itemTime = this.item.createTime1
      const timeTnterval = parseInt((nowTime - itemTime) / 1000 / 60)
      // 超过三秒不显示撤回,别人的消息不能撤回
      if (timeTnterval > 3) return
      if (!this.isSelf(this.item.sendType)) return
      let x = 0
      let y = 0
      if (event.clientX) {
        // 鼠标右键执行
        event.preventDefault()
        x = event.clientX
        y = event.clientY
      } else {
        // 屏幕长按执行
        x = event.touches[0].clientX
        y = event.touches[0].clientY
      }
      this.clientX = x - 80
      this.clientY = y - 10
      this.isMenuFlag = true
      this.$refs.messageDrop.style.display = 'none'
      this.$refs.messageDrop.style.display = 'block'
    },
    hideDropdown() {
      this.isMenuFlag = false
    }
    /* handleTouchStart( e ) {
             this.touchX = e.touches[0] && e.touches[0].clientX
             this.touchY = e.touches[0] && e.touches[0].clientY
             e.preventDefault()
             this.timer = setTimeout( () => {
               this.timer = null
               this.handleContextMenu( e )
             }, 800 )
           },
           handleTouchEndMove1( e ) {
             e.preventDefault()
             const touchX = e.touches[0] && e.touches[0].clientX
             const touchY = e.touches[0] && e.touches[0].clientY
             if( Math.abs( touchX - this.touchX ) < 5 && Math.abs( touchY - this.touchY ) < 5 ) return
             clearTimeout( this.timer )
           },
           handleTouchEndMove2( e ) {
             e.preventDefault()
             clearTimeout( this.timer )
           }*/
  }
}
</script>
<style lang="stylus" scoped>
  :focus {
    outline: 0;
  }
  .el-popper {
    padding: 0;
    overflow: hidden;
  }
  .drop-down-wrapper {
    display: flex;
    align-items: center;
  }
  .right-click-menu-wrapper {
    .menu-card-wrapper {
      width 80px
      box-sizing border-box
      position: fixed;
      z-index: 99999;
      user-select: none;
      background: #fff;
      box-shadow 1px 1px 10px 1px #ccc
      border-radius 3px
      text-align center
      overflow hidden
      .dropdown {
        width: 100%;
        height: 100%;
        display: block;
        .dropdown-menu {
          color #333
          font-size 13px
          line-height 30px;
          cursor pointer
          &:hover {
            color #5693ff
          }
        }
      }
    }
  }
</style>
